import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { BaseService } from 'src/app/core/services/base.service';

@Injectable({
    providedIn: 'root',
})
export class SharedRankingListService extends BaseService {
    constructor(private http: HttpClient) {
        super();
    }

    getRankingsFilter(departmentType, filters): Observable<any> {
        // Instacia o body através de BaseSerive.setBody();
        let body = this.setBody();

        // Inicializar o id do departamento selecionado
        body.set('departmentType', departmentType);

        if (filters !== null) {
            Object.keys(filters).forEach((filter) => {
                if (filters[filter] !== null && filters[filter] !== '') {
                    if (filters[filter] instanceof Array) {
                        body.set(filter, `[${filters[filter].join(',')}]`);
                    } else {
                        body.set(filter, filters[filter]);
                    }
                }
            });
        }

        let response = this.http
            .post(this.urlService + this.routeAdress.route_rankings_filter, body.toString())
            .pipe(map(this.extractData), catchError(this.serviceError));

        return response;
    }
}
